import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import './SliderArrow.scss'

library.add(faArrowRight, faArrowLeft)

export default ({ className, faIcon, to, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`button button--text button--icon ${className}`}
    aria-label={to}
  >
    {/* <FontAwesomeIcon icon={['fas', 'search-plus']} /> */}
    {/* <FontAwesomeIcon icon={['fas', 'filter']} /> */}
    {/* <FontAwesomeIcon icon={faCoffee} /> */}
    <FontAwesomeIcon icon={`${faIcon}`} />
    {/* <i className={`fa ${faIcon}`} /> */}
  </button>
)
